"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var palette_1 = require("../constants/palette");

var scales_1 = require("../constants/scales");

var spacing_1 = require("../systems/spacing"); // TODO: Themed component


var Drawer = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #54bfda;\n  min-width: ", "px;\n  max-width: ", "px; // IE11 fix\n  align-self: stretch;\n  color: ", ";\n  text-align: center;\n  @media only screen and (max-width:767px) {\n    flex-basis: initial;\n    margin-top: 55px;\n    max-width: 100%; // IE11 fix\n  }\n  ", ";\n"], ["\n  background-color: #54bfda;\n  min-width: ", "px;\n  max-width: ", "px; // IE11 fix\n  align-self: stretch;\n  color: ", ";\n  text-align: center;\n  @media only screen and (max-width:767px) {\n    flex-basis: initial;\n    margin-top: 55px;\n    max-width: 100%; // IE11 fix\n  }\n  ", ";\n"])), scales_1.fixedScale[10], scales_1.fixedScale[10], palette_1.default.white, function (props) {
  return spacing_1.default(props);
});
exports.default = Drawer;
var templateObject_1;